module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "star",
    class: _vm.starType
  }, _vm._l((_vm.itemClasses), function(itemClass, index) {
    return _c('span', {
      key: index,
      staticClass: "star-item",
      class: itemClass
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79237b3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/star/star.vue
// module id = 56
// module chunks = 0